import { CheckCircle2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { FlowProgress } from "@/components/consultation-flow/ui/FlowProgress";
import { flowPhaseProgress, refinedStep } from "@/lib/pharmacyFirst/engine/refinedFlowUi";
import type { Pathway } from "@/lib/pharmacyFirst/types";

interface PathwayProgressHeaderProps {
  pathway: Pathway;
  answeredVisibleCount: number;
  answeredNodesCount: number;
  progressPercent: number;
  paymentTriggered: boolean;
  isDarkMode: boolean;
}

export function PathwayProgressHeader({
  pathway,
  answeredVisibleCount,
  answeredNodesCount,
  progressPercent,
  paymentTriggered,
  isDarkMode,
}: PathwayProgressHeaderProps) {
  const payment = paymentTriggered && (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 border border-emerald-200">
      <CheckCircle2 className="h-3.5 w-3.5" />
      Payment claimable
    </span>
  );
  const phase = flowPhaseProgress(pathway, answeredVisibleCount);

  if (phase) {
    return (
      <>
        {payment && <div className="flex justify-end mb-2">{payment}</div>}
        <FlowProgress phase={phase.phase} step={phase.step} totalSteps={phase.total} isDarkMode={isDarkMode} />
      </>
    );
  }

  const refined = refinedStep(pathway, answeredVisibleCount);
  return (
    <>
      <div className="flex items-center justify-between mb-2">
        <span />
        <div className="flex items-center gap-3">
          {payment}
          {!pathway.hideStepCounter && (
            <p className={`text-sm font-medium ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
              {refined?.label ?? `Step ${answeredNodesCount + 1}`}
            </p>
          )}
        </div>
      </div>
      <Progress value={refined?.percent ?? progressPercent} className="h-2" />
    </>
  );
}
